import React from 'react';
import { Select, MenuItem, Avatar } from "@material-ui/core";

import SpotlioIcon from '../Icon';

import { getUserSettings, setUserSettings, getSystemSettings, getCurrencyDatabase } from '../../utils/SettingsRetriever';

import './index.scss';
import CurrencyDatabase from '../../utils/CurrencyDatabase';

export default class CurrencySelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCurrency: getUserSettings() && getUserSettings().currencies && getUserSettings().currencies.selected,
            currenciesList: getSystemSettings().app.currency,
            displayModal: false
        };
    }

    handleUpdateSystemSettings = () => {
        const UserSettings = getUserSettings();
        setUserSettings({
            ...UserSettings,
            currencies: {
                ...UserSettings.currencies,
                selected: this.state.selectedCurrency
            }
        });
        this.setState({...this.state}, () => {
            const currencyDB = getCurrencyDatabase();
            console.log(currencyDB);
            const event = new CustomEvent("changeCurrency");
            if (currencyDB === false) {
                CurrencyDatabase(getSystemSettings()).then(() => {
                    document.dispatchEvent(event);
                })
            } else {
                document.dispatchEvent(event);
            }
        });
    }

    handleToggleCurrencyModal = () => {
        const modalState = !this.state.displayModal;
        this.setState({...this.state, displayModal: modalState});
    }

    handleSelectCurrency = (index) => {
        this.setState({...this.state, selectedCurrency: index, displayModal: false}, () => this.handleUpdateSystemSettings());
    }

    render() {
        if(this.state.currenciesList.list.length === 1) return '';

        let CurrencyLink = '';
        if (this.props.mode === "b2b") {
            CurrencyLink = <Avatar className={(this.props.className || '') + " CurrencySelectorButton Avatar"} onClick={() => this.handleToggleCurrencyModal()}>{this.state.currenciesList.list[this.state.selectedCurrency].base}</Avatar>
        } else {
            CurrencyLink =  (
                <Select 
                    IconComponent={() => <SpotlioIcon icon="feather-chevron-down" />} 
                    value={this.state.selectedCurrency}
                    onChange={(e) => this.handleSelectCurrency(e.target.value)}
                >
                    {
                        this.state.currenciesList.list.map((val, idx) => {
                            return (
                                <MenuItem key={val.base} className="CurrencyItem" value={idx}>
                                    <span>{val.symbol}</span>
                                    <span>{val.base}</span>
                                    <span>{val.name}</span>
                                </MenuItem>
                            )
                        })
                    }
                </Select>
            )
        }

        return (
            <React.Fragment>
                { CurrencyLink }
            </React.Fragment>
        );
    }
}
